module.exports = __webpack_public_path__ + "img/01.1c9e11c4.png";